import { Divider } from "@material-ui/core";
import { Container, Grid } from "@mui/material";
import axios from "axios";
import {
  ColorPickerInput,
  CurrencyNumberInput,
  FormCard,
  FormLabel,
  FormUploadImage,
  ModalError,
  ModalSuccess,
  NumberInput,
  Page,
  PrimaryButton,
  SectionLabel,
  SelectInput,
  SkeletonComponent,
  TextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";

const FormParameterClient = () => {
  const classes = globalStyles();
  const history = useHistory();
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(true);
  const [optionCurrency, setOptionCurrency] = useState([]);
  const [optionClientClassification, setOptionClientClassification] = useState(
    []
  );
  const [payload, setPayload] = useState({
    type: "non_dsp",
    client_classification_id: 0,
    name: "",
    domicile: "domestic",
    image_logo: "",
    color: "#000000",
    person_name: "",
    person_phone: "",
    person_email: "",
    address: "",
    type_upload: "manual",
    currency_id: "",
    transaction_fee: "",
  });
  const [dspLogo, setDspLogo] = useState({
    image_url: null,
    image: null,
  });
  const pageTitle = `${id ? "Edit" : "Add"} Client`;

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };

  const getDetail = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/dsp/${id}`, { headers });
      const { data } = res?.data;
      const requiredKeys = [
        "type",
        "name",
        "domicile",
        "color",
        "person_name",
        "person_phone",
        "person_email",
        "address",
        "currency_id",
        "transaction_fee",
      ];
      const filteredData = requiredKeys?.reduce((acc, key) => {
        acc[key] = data[key];
        return acc;
      }, {});
      setPayload({
        client_classification_id:
          data?.client_classification?.client_classification_id,
        image_logo: data?.profile_image,
        type_upload: data?.upload_type,
        ...filteredData,
      });
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    }
  };
  const getOptionCurrency = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/currency/datatable?page=1&per_page=100`,
        { headers }
      );
      setOptionCurrency(res?.data?.data);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    }
  };
  const getOptionClientClassification = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/publisher/classification/index`,
        { headers }
      );
      setOptionClientClassification(res?.data?.data);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    }
  };
  const fetchData = async () => {
    setLoadingPage(true);
    const promises = [getOptionClientClassification(), getOptionCurrency()];
    if (id) {
      promises.push(getDetail());
    }

    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSubmit = async () => {
    const method = id ? axios.put : axios.post;
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    if (dspLogo?.image) {
      formData.append("image_logo", dspLogo?.image || "");
    }
    try {
      setLoadingPage(true);
      await method(`${hardBaseUrl}/dsp${id ? `/${id}` : ""}`, formData, {
        headers,
      });
      ModalSuccess(`Succesfully ${id ? "update" : "save"} client`).then(() =>
        history.goBack()
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Page className={classes.root} title={pageTitle}>
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title={pageTitle}
            breadcrumbData={breadcrumbData({ pageTitle })}
            backButton
          />
          <Divider className={classes?.divider} />
          <Grid container direction="column" rowSpacing={2}>
            <Grid item>
              <SectionLabel
                title="Client Information"
                subTitle="Information about DSP that has been joined to us"
              />
              <FormCard>
                <Grid container columnSpacing={2} rowSpacing={2}>
                  {MockFieldFormClientInformation({
                    optionClientClassification,
                  }).map(
                    ({
                      key,
                      options,
                      title,
                      type,
                      optionKey,
                      optionLabel,
                      optional,
                      placeholder,
                    }) => (
                      <Grid
                        item
                        key={key}
                        xs={12}
                        md={
                          type === "upload_image" || type === "color_picker"
                            ? 12
                            : 6
                        }
                      >
                        <FormLabel label={title} required={!optional} />
                        {type === "upload_image" ? (
                          <FormUploadImage
                            imageUrl={dspLogo.image_url || payload?.image_logo}
                            setImageLogo={setDspLogo}
                            noLabel
                          />
                        ) : type === "color_picker" ? (
                          <ColorPickerInput
                            value={payload?.color}
                            onChange={color =>
                              handleChangePayload(color, "color")
                            }
                          />
                        ) : type === "select" ? (
                          <SelectInput
                            options={options}
                            optionKey={optionKey || "id"}
                            optionLabel={optionLabel || "name"}
                            value={payload?.[key] || ""}
                            onChange={e =>
                              handleChangePayload(e?.target?.value, key)
                            }
                            placeholder={placeholder}
                            width="100%"
                          />
                        ) : (
                          <TextInput
                            placeholder={title}
                            value={payload?.[key]}
                            onChange={e =>
                              handleChangePayload(e?.target?.value, key)
                            }
                          />
                        )}
                      </Grid>
                    )
                  )}
                </Grid>
              </FormCard>
            </Grid>
            <Grid item>
              <SectionLabel title="PIC" subTitle="Information about PIC" />
              <FormCard>
                <Grid container columnSpacing={2} rowSpacing={2}>
                  {MockFieldFormPIC.map(
                    ({ key, title, type, multiline, optional }) => (
                      <Grid item key={key} xs={12} md={multiline ? 12 : 6}>
                        <FormLabel label={title} required={!optional} />
                        {type === "phone" ? (
                          <NumberInput
                            value={payload?.[key]}
                            placeholder={title}
                            onChange={val => handleChangePayload(val, key)}
                          />
                        ) : (
                          <TextInput
                            placeholder={title}
                            value={payload?.[key]}
                            onChange={e =>
                              handleChangePayload(e?.target?.value, key)
                            }
                            multiline={multiline}
                            rows={multiline ? 4 : 1}
                          />
                        )}
                      </Grid>
                    )
                  )}
                </Grid>
              </FormCard>
            </Grid>
            <Grid item>
              <SectionLabel
                title="Transfer & Fee Currency"
                subTitle="To Settings Transfer Fee & Currency of Client"
              />
              <FormCard>
                <Grid container columnSpacing={2} rowSpacing={2}>
                  {MockFieldFormTransferFee.map(({ key, title, type }) => (
                    <Grid item key={key} xs={12} md={6}>
                      <FormLabel label={title} />
                      {type === "select" ? (
                        <SelectInput
                          options={optionCurrency}
                          optionKey="id"
                          optionLabel="currency_iso_code"
                          value={payload?.[key] || ""}
                          onChange={e =>
                            handleChangePayload(e?.target?.value, key)
                          }
                          placeholder="None"
                          width="100%"
                        />
                      ) : (
                        <CurrencyNumberInput
                          value={payload?.[key]}
                          onChange={val => handleChangePayload(val, key)}
                          decimalScale={2}
                        />
                      )}
                    </Grid>
                  ))}
                </Grid>
              </FormCard>
            </Grid>
            <Grid item>
              <Grid container justifyContent="right">
                <PrimaryButton label="Save" onClick={handleSubmit} />
              </Grid>
            </Grid>
          </Grid>
        </Container>
      )}
    </Page>
  );
};

const breadcrumbData = ({ pageTitle }) => [
  {
    label: "Parameter",
    link: "/admin/parameter/dsp",
  },
  {
    label: "Client",
    link: "/admin/parameter/dsp",
  },
  {
    label: pageTitle,
    active: true,
  },
];
const optionClientType = [
  { id: "dsp", name: "DSP" },
  { id: "non_dsp", name: "Non DSP" },
];
const optionDomicile = [
  { id: "domestic", name: "Domestic" },
  { id: "overseas", name: "Overseas" },
];
const MockFieldFormClientInformation = ({ optionClientClassification }) => [
  {
    title: "Client Type",
    key: "type",
    type: "select",
    options: optionClientType,
  },
  {
    title: "Client Classification",
    key: "client_classification_id",
    type: "select",
    options: optionClientClassification,
    optionLabel: "classification_name",
    optionKey: "client_classification_id",
    placeholder: "None",
    optional: true,
  },
  {
    title: "Client Name",
    key: "name",
  },
  {
    title: "Domicile",
    key: "domicile",
    type: "select",
    options: optionDomicile,
  },
  { title: "Client Logo", type: "upload_image", optional: true },
  { title: "Identity Color", type: "color_picker" },
];
const MockFieldFormPIC = [
  {
    title: "PIC Name",
    key: "person_name",
  },
  {
    title: "Phone Number",
    key: "person_phone",
    type: "phone",
  },
  {
    title: "Email",
    key: "person_email",
    optional: true,
  },
  {
    title: "Address",
    key: "address",
    multiline: true,
  },
];
const MockFieldFormTransferFee = [
  {
    title: "Currency",
    key: "currency_id",
    type: "select",
  },
  {
    title: "Transfer Fee",
    key: "transaction_fee",
  },
];
export default FormParameterClient;
